"use client";

import { MapPin, CheckCircle2 } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Serviceareas() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll();
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll();

  // Tu lista exacta de áreas
  const areas = ["Miami Beach", "South Miami", "Kendall", "Opa-Locka", "Broward", "Fort Lauderdale"];
  return <section data-section-id="906" id="serviceareas" className="bg-background py-20 md:py-28 lg:py-32 border-t border-border">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          <div ref={leftRef} className={`order-2 lg:order-1 flex flex-col justify-center transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="text-xs font-medium tracking-[0.2em] uppercase text-secondary mb-5 font-default">
              Local Service
            </p>
            <h3 className="font-display font-default text-4xl md:text-5xl leading-[1.1] tracking-tight text-foreground mb-10">
              Areas We Serve:
            </h3>

            {/* Lista de ubicaciones */}
            <div className="pt-6 border-t border-border">
              <div className="flex items-start gap-3">
                <MapPin className="w-6 h-6 text-primary mt-1 shrink-0" strokeWidth={1.5} />
                <ul className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 mt-1">
                  {areas.map((area, i) => <li key={i} className="flex items-center gap-2 text-lg text-foreground font-default">
                      <CheckCircle2 className="w-5 h-5 text-secondary" strokeWidth={2} />
                      {area}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>

          <div ref={rightRef} className={`order-1 lg:order-2 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <div className="relative h-[420px] rounded-lg overflow-hidden shadow-medium border border-border">
              {/* Mapa centrado en el área de Miami/Broward (Puedes ajustar la URL del src) */}
              <iframe title="Service Area Map" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Miami,FL+(AA%20Eagle%20Plumbing)&amp;t=&amp;z=10&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" className="absolute inset-0 w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen />
            </div>
          </div>
        </div>
      </div>
    </section>;
}